import { EventRow } from './logger.event-row';
import { loggerConstants } from './logger.constants';
import type { IExtendedTelemetryItem } from '@microsoft/1ds-analytics-web-js';
import { Metamodel, ModelConstants, Named } from 'shell-models-lib';
import type { ILoggerOptions } from 'app/interfaces/IIFrameMessage';


export enum FabricFeatureName {
    DIPipelineCopilotUI = 'DIPipelineCopilotUI',
    Pipeline = 'Pipeline',
    CopyJob = 'CopyJob',
    MountedRelationalDatabase = 'MountedRelationalDatabase'
}

export const getFabricFeatureName = (named: Pick<Named, 'name'>): FabricFeatureName.Pipeline | FabricFeatureName.CopyJob => { // Need add mirror/airflow artifact etc 
    const fabricArtifactName = Metamodel.modelOf(named)?.name;
    const featureName = ModelConstants.pipeline === fabricArtifactName
        ? FabricFeatureName.Pipeline
        : ModelConstants.copyJob === fabricArtifactName
            ? FabricFeatureName.CopyJob
            : undefined;
    return featureName;
}

/**
 *  @param operationName: string; // need consistant with fabric feature usage constants
 *  @param status: 'Started' | 'Succeeded' | 'Failed' | 'Cancelled' | 'Pending' | 'SucceededWithErrors' | 'FailedWithRemote' | 'Interrupted'
 *  @param startTime: Date;
 *  @param endTime: Date;
 *  @param activityAttributes?: Record<string, string | number | boolean>;
 */
export class FabricCertifiedEvent extends EventRow {
    constructor(
        featureName: FabricFeatureName,
        operationName: string,
        status: string = 'Succeeded',
        startTime: Date = new Date(),
        endTime: Date = new Date(),
        activityAttributes?: Record<string, string | number | boolean>,
        private loggerOptions?: ILoggerOptions
    ) {
        super(loggerConstants.Event_FabricCertifiedUsage, {
            featureName,
            operationName,
            status,
            startTime: startTime.toISOString(),
            endTime: endTime.toISOString(),
            activityAttributes
        });
    }

    public generateLoggingEntry(): IExtendedTelemetryItem {
        return {
            name: loggerConstants.Event_FabricCertifiedUsage,
            data: {
                eventName: this.eventName,
                featureName: this.properties.featureName,
                operationName: this.properties.operationName,
                status: this.properties.status,
                startTime: this.properties.startTime,
                endTime: this.properties.endTime,
                activityAttributes: this.properties.activityAttributes
            }
        };
    }

    getLoggerOptions(): ILoggerOptions {
        return this.loggerOptions;
    }
}
